import React from 'react';
import PropTypes from 'prop-types';
import Page from '../Page';
import SandboxForm from '../../components/SandboxForm';

const Free = (props) => {
  return (
    <Page { ...props } alignment="left" heading="Gratis proberen">
      <div>
        <p>
          Je kunt Postcode API uitproberen door hieronder te registreren voor een gratis API key. Hiermee kun je kijken of je de API werkend krijgt in jouw applicatie en of het voldoet aan jouw behoeften. Als dit het geval is kun je eenvoudig upgraden naar een betaald pakket en hoef je alleen nog maar de URL aan te passen!
        </p>
      </div>
      <SandboxForm plan={ props.head.plan } />
    </Page>
  )
};

Free.propTypes = {
  head: PropTypes.object.isRequired,
  body: PropTypes.string,
};

export default Free;
